import type { CurrencyFormatSettings } from '../../../../../types/Configuration';
import { UTF_CHARACTER_SET } from './constants';
import selectCurrencyFormat from './selectCurrencyFormat';
import { NO_BREAK_SPACE } from './unbreakableSpaces';

const DEFAULT_PRICE_FORMAT = '{SYMBOL}{AMOUNT} {CODE}';

const formatPriceWithCurrency = (
  formattedAmount: string,
  currencyConfig: CurrencyFormatSettings | undefined,
  symbol: string,
  code: string,
  language: string,
) => {
  const currencySpecificFormat = selectCurrencyFormat(currencyConfig, code, language);

  const stringFormat = currencySpecificFormat?.stringFormat ?? currencyConfig?.stringFormat ?? DEFAULT_PRICE_FORMAT;
  const formattedString = stringFormat
    .replace('{SYMBOL}', symbol)
    .replace('{AMOUNT}', formattedAmount)
    .replace('{CODE}', code);

  // this check is used for widgets to avoid displaying unexpected characters when a partner injects canvas code on a non-UTF-8 page
  if (document.characterSet === UTF_CHARACTER_SET) return formattedString.replace(/ /g, NO_BREAK_SPACE);
  return formattedString;
};

export default formatPriceWithCurrency;
